import { useSearchParams } from 'react-router';
import { Box } from '@chakra-ui/react';
import Pagination from '@components/Pagination';
import type { FiltersType } from '@customTypes/filters';

type Props = {
  total: number,
  onPaginationChange: (filters: FiltersType) => void,
  children: React.ReactNode,
};

const PaginationRouterContainer = ({
  total, onPaginationChange, children,
}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const pageParam = Number(searchParams.get('page')) || 1;
  const limitParam = Number(searchParams.get('limit')) || 10;

  const defaultPage = pageParam < 1 ? 1 : pageParam;
  const defaultLimit = (limitParam > 100 || limitParam < 1) ? 10 : limitParam;

  const handleWithPaginationChange = (page: number, limit: number) => {
    onPaginationChange({ page, limit });

    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', page.toString());
    newParams.set('limit', limit.toString());
    setSearchParams(newParams);
  };

  return (
    <Box>
      <Pagination
        limit={defaultLimit}
        total={total}
        page={defaultPage}
        onPaginationChange={handleWithPaginationChange}
      />

      {children}

      <Pagination
        limit={defaultLimit}
        total={total}
        page={defaultPage}
        onPaginationChange={handleWithPaginationChange}
      />
    </Box>
  );
};

export default PaginationRouterContainer;
